import {
	deliveryToContact,
	deliveryToEstablishment,
	findContact,
	findEstablishment,
	toDeliveryPayload
} from "@/services/deliveryInfos";

export function saveDelivery(vm, { establishment, contact }) {
	vm.$store.commit("setDeliveryFields", toDeliveryPayload({ establishment, contact }));
}

export function resetDelivery(vm) {
	vm.$store.commit("resetDeliveryFields");
}

// delivery = vm.$store.state.home.delivery
export function resolveEstablishment({ contactInfos, currentSelection, delivery = {} }) {
	const { establishmentId, establishment } = findEstablishment({
		contactInfos,
		establishment_id: delivery.establishment_id
	});

	if (!establishmentId || !establishment) {
		return deliveryToEstablishment(delivery) ?? currentSelection;
	}
	return establishment;
}

export function resolveContact({ contactInfos, currentSelection, delivery = {} }) {
	const contact = findContact({ contactInfos, email: delivery.email });
	if (!contact) {
		return (
			deliveryToContact({
				...delivery,
				establishments: contactInfos?.establishments ?? []
			}) ?? currentSelection
		);
	}
	return contact;
}

// Ouvre la modale d'édition pour n'importe quel établissement dans le contexte livraison.
// is_delivery: true est toujours forcé pour que le watcher contactInfos.establishments
// puisse détecter si la modale a été ouverte depuis le bloc livraison.
export function openEstablishmentModal(vm, establishment, isThirdAccount) {
	vm.isThirdAccountGlobal = isThirdAccount;
	vm.$store.commit("editableEstablishment", { ...establishment, is_delivery: true });
	vm.$store.commit("showEditAddressModal", true);
	vm.$store.commit("renderGA", true);
}

export function openAddressModal(vm, isThirdAccount) {
	openEstablishmentModal(
		vm,
		{
			id: 0,
			contacts: null,
			details: null,
			emails: null,
			is_favorite: null,
			is_headquarter: 0,
			name: null,
			nic: null,
			phones: null,
			place: null
		},
		isThirdAccount
	);
}

export function openDeliveryAddressModal(vm, isThirdAccount) {
	openAddressModal(vm, isThirdAccount);
}
